import defaults, { metersPerMile } from '@config/defaults'
import * as amplitude from '@amplitude/analytics-browser'

// Constants
const DEFAULT_PRECISION = 10 // meters

/**
 * Calculates the aroundPrecision value in meters based on the feature flags
 * @param {string|null} experimentValue - The experiment value ('false', '0', '2', '4', '6', '8', '10', or null)
 * @param {boolean} isSearchPriorityEnabled - Whether the search priority flag is enabled
 * @param {boolean} isPrecisionRangesEnabled - Whether the precision ranges flag is enabled
 * @returns {number|Array} The aroundPrecision value in meters or precision ranges array
 */
export const getAroundPrecision = (experimentValue, isSearchPriorityEnabled, isPrecisionRangesEnabled) => {
  let precision
  let source = 'default'

  // If experiment value is provided and not 'false', convert to meters
  if (experimentValue && experimentValue !== 'false') {
    const miles = parseInt(experimentValue, 10)
    precision = Math.round(Math.max(DEFAULT_PRECISION, miles * metersPerMile))
    source = 'experiment'
  } else if (isSearchPriorityEnabled || isPrecisionRangesEnabled) {
    // If either search priority or precision ranges are enabled, return the ranges
    precision = defaults.geoSearchPrecisionRanges
    source = isSearchPriorityEnabled ? 'search_priority' : 'precision_ranges'
  } else {
    // Default to 10 meters if no flags are enabled
    precision = DEFAULT_PRECISION
  }

  // Track the precision value and its source
  amplitude.track('coach-search-precision', {
    precision_value: precision,
    precision_source: source,
    experiment_value: experimentValue,
    search_priority_enabled: isSearchPriorityEnabled,
    precision_ranges_enabled: isPrecisionRangesEnabled,
  })

  return precision
}
